import { inject, Injectable } from '@angular/core';
import { BrandingManagerService } from '@rx-applications/shared/branding/api';

@Injectable({
  providedIn: 'root',
})
export class FaviconService {
  readonly #brandingManager = inject(BrandingManagerService);

  setFavicon(): void {
    const favicon = this.#brandingManager.getBrandAccess().getFavicon();
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = favicon;
    document.getElementsByTagName('head')[0].appendChild(link);
  }
}
